import { render } from "./CustomFinish.vue?vue&type=template&id=e3598c6e"
import script from "./CustomFinish.vue?vue&type=script&lang=js"
export * from "./CustomFinish.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__